export const deliveredBy = () => {
    return [
        { value: "STORETODOOR", label: "Store2Door" },
        { value: "SELF", label: "Self" },
    ]
}

export const customerType = () => {
    return [
        { value: "TOURIST", label: "Tourist" },
        { value: "RESIDENT", label: "Resident" },
        { value: "OVERSEASCUSTOMER", label: "Overseas Shoppers" },
    ]
}

export const serviceOption = () => {
    return [
        { value: "Service1", label: "Service1" },
        { value: "Service2", label: "Service2" },
    ]
}

export const customerTypeNew = () => {
    return [
        { value: "Individual", label: "Individual" },
        { value: "Retailer", label: "Retailer" },
        { value: "Corporate", label: "Corporate" },
        { value: "Commercial", label: "Commercial" },
    ]
}

export const endcustomerType = () => {
    return [
        { value: "Tourist", label: "Tourist" },
        { value: "Expat", label: "Expat" },
        { value: "Overseas Customer", label: "Overseas Customer" },
        { value: "Commercial", label: "Commercial" }
    ]
}

export const serviceType = () => {
    return [
        { value: "NONE", label: "Select" },
        { value: "PORT", label: "Door to Port" },
        { value: "DOOR", label: " Door to Door - Direct" },
        { value: "CONSOLIDATION", label: "Door to Door - Consolidation" },
        { value: "OTHER", label: "Other Service" },
    ]
}

export const shipmentAssorment = () => {
    return [
        { value: "NOT_RECEIVED", label: "Not Received" },
        { value: "RECEIVED", label: "Received"},
        { value: "PARTIAL_RECEIVED", label: "Partial Received"},
    ]
}

export const shipmentType = () => {
    return [
        { value: "NONE", label: "Select" },
        { value: "LCL", label: "LCL" },
        { value: "20FT", label: "20ft" },
        { value: "40FT", label: "40ft" },
        { value: "AIR", label: "Air" },
        { value: "COURIER", label: "Courier" },
        { value: "LAND", label: "Land" },
        { value: "STORAGE", label: "Storage" },
        { value: "LOCAL_MOVING", label: "Local Moving"},
        { value: "LOCAL_TRANSPORT", label: "Local Transport" },
        { value: "LOCAL_PACKING", label: "Local Packing" },
        { value: "DOCUMENTATION", label: "Documentation" },
        { value: "OTHER_SERVICES", label: "Other Services" },
    ]
}

export const shippingMode = () => {
    return [
        { value: "NONE", label: "Select" },
        { value: "AIR", label: "Air Frt" },
        { value: "SEA", label: "Sea Frt" },
        { value: "COURIER", label: "Courier" },
        { value: "LAND", label: "Land Frt" },
        { value: "LOCAL", label: "Local" },
    ]
}

export const shipmentCategory = () => {
    return [
        { value: "Commercial", label: "Commercial" },
        { value: "Personal ( New)", label: "Personal ( New)" },
        { value: "Relocation", label: "Relocation" },
        { value: "Mix ( Relocation & New)", label: "Mix ( Relocation & New)" },
    ]
}



export const warehouseOptions = () => {
    return [
        { value: "Warehouse1", label: "Warehouse 1" },
        { value: "Warehouse2", label: "Warehouse 2" },
        { value: "Warehouse3", label: "Warehouse 3" },
    ]
}

export const packingOption = () => {
    return [
        { value: "pallet_packing", label: "Pallet Packing" },
        { value: "crate_packing", label: "Crate Packing" },
        { value: "carton_packing", label: "Carton Packing" },
    ]
}

export const timeslotStart = () => {
    return [
        { value: "01:00 - 02:00", label: "01:00 - 02:00" },
        { value: "02:00 - 03:00", label: "02:00 - 03:00" },
        { value: "03:00 - 04:00", label: "03:00 - 04:00" },
        { value: "04:00 - 05:00", label: "04:00 - 05:00" },
        { value: "05:00 - 06:00", label: "05:00 - 06:00" },
        { value: "06:00 - 07:00", label: "06:00 - 07:00" },
        { value: "07:00 - 08:00", label: "07:00 - 08:00" },
        { value: "08:00 - 09:00", label: "08:00 - 09:00" },
        { value: "09:00 - 10:00", label: "09:00 - 10:00" },
        { value: "10:00 - 11:00", label: "10:00 - 11:00" },
        { value: "11:00 - 12:00", label: "11:00 - 12:00" },
    ]
}

export const cargoTypes = () => {
    return [
        { value: "electronics", label: "Electronics" },
        { value: "home_furnishing", label: "Home Furnishing" },
        { value: "toy_store", label: "Toy Store" },
        { value: "carpet", label: "Carpet" },
        { value: "sports_goods", label: "Sports Goods" },
        { value: "e_commerce", label: "E Commerce" },
        { value: "department_stores", label: "Department Stores" },
        { value: "fashion", label: "Fashion" },
        { value: "footwear", label: "Footwear" },
        { value: "general", label: "General" },
    ]
}

export const paymentOption = () => {
    return [
        { value: "Paid", label: "Paid" },
        { value: "Part Paid", label: "Part Paid" },
        { value: "Not Paid", label: "Not Paid" },
    ]
}

export const pickUpOption = () => {
    return [
        { value: "SELF", label: "Self" },
        { value: "WORLD2DOOR", label: "World2door" },
        { value: "RETAILER", label: "Retailer" },
    ]
}
export const statusOption = () => {
    return [
        { value: "PENDING", label: "PENDING" },
        { value: "ASSIGNED", label: "ASSIGNED" },
        { value: "RECEIVED", label: "RECEIVED" },
    ]
}

export const shipmentStatusOpt = () => {
    return [
        { value: "BOOKING_CONFIRMED", label: "Pick Up in progress" },
        { value: "SHIPMENT_AT_WAREHOUSE", label: "Export formalities in progress" },
        { value: "DEPARTED", label: "In transit" },
        { value: "ARRIVED", label: "Import formalities in progress" },
        { value: "DELIVERED", label: "DELIVERED" },
    ]
}

export const shipmentStatusOptForSameDesCon = () => {
    return [
        { value: "BOOKING_CONFIRMED", label: "Pick Up in progress" },
        { value: "DEPARTED", label: "In transit" },
        { value: "DELIVERED", label: "DELIVERED" },
    ]
}

export var paymmentInformation = () => {
    return {
        booking_amount: '',
        actual_amount: '',
        agreed_amount: '',
        payment_status: '',
        breakdown: {
            insurance: 0,
            storage: 0,
            packing_charge: 0,
            freight: 0,
            bookingAmount: 0,
            discount_amount: 0
        }
    }
}
export const endCustomerType = () => {
    return [
        { value: "Tourist", label: "Tourist" },
        { value: "Expat", label: "Expat" },
        { value: "Overseas Customer", label: "Overseas Customer" },
        { value: "Commercial", label: "Commercial" },
    ]
}

export const userTypeList = () => {
    return [{ value: 'individual', label: 'Individual' },
    { value: 'commercial', label: 'Commercial' }]
}